/**
 * helpSlice — Get Help FAQ list.
 *
 * Ported from event-management. Hydrated by HelpInitializer from the server
 * render (`getFaqListSSR()`); the FAQ accordion reads `faqs` from here.
 * Read-only — the Help Center has no mutations.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { FaqEntry } from "@/components/help/faqData";

export interface HelpState {
  faqs: FaqEntry[];
  loading: boolean;
}

const initialState: HelpState = {
  faqs: [],
  loading: true,
};

const helpSlice = createSlice({
  name: "help",
  initialState,
  reducers: {
    /** Replace the FAQ list — used to hydrate from the server render. */
    setFaqs(state, action: PayloadAction<FaqEntry[]>) {
      state.faqs = action.payload;
    },
    setHelpLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setFaqs, setHelpLoading } = helpSlice.actions;

export default helpSlice.reducer;
